import React, { useState, useRef, useEffect } from 'react';
import './TestimonialSection.css';

const TestimonialSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);
  const carouselRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      content: "Professional team with quick response time. They understood our needs and delivered beyond expectations. Their dedication and support made the entire process seamless. Looking forward to continuing our partnership.",
      author: "Amit Dhakal",
      context: "Managing Director",
      color: "green"
    },
    {
      id: 2,
      content: "CodeGenexis delivered an exceptional website that perfectly captures our brand essence. The design is modern, user-friendly, and has significantly improved our online presence. Highly recommended!",
      author: "Sujan Thapa",
      context: "Managing Director",
      color: "yellow"
    },
    {
      id: 3,
      content: "The team at CodeGenexis is incredibly professional and creative. They transformed our outdated website into a stunning, modern platform that our customers love. The process was smooth and collaborative.",
      author: "Sam Karki",
      context: "Operational Management",
      color: "blue"
    },
  ];

  const totalSlides = Math.ceil(testimonials.length / 3);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX);
    setCurrentX(e.clientX);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setCurrentX(e.clientX);
  };

  const handleMouseUp = () => {
    if (!isDragging) return;
    
    const diff = startX - currentX;
    const threshold = 100; // Minimum distance to trigger slide change
    
    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        // Swiped left - go to next slide
        nextSlide();
      } else {
        // Swiped right - go to previous slide
        setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
      }
    }
    
    setIsDragging(false);
  };

  const goToSlide = (slideIndex) => {
    setCurrentSlide(slideIndex);
  };

  const getCurrentTestimonials = () => {
    const startIndex = currentSlide * 3;
    return testimonials.slice(startIndex, startIndex + 3);
  };

  // Auto-slide functionality
  useEffect(() => {
    const autoSlideInterval = setInterval(() => {
      nextSlide();
    }, 10000); // 10 seconds

    return () => clearInterval(autoSlideInterval);
  }, [currentSlide]);

  // Add event listeners for mouse events
  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    carousel.addEventListener('mousedown', handleMouseDown);
    carousel.addEventListener('mousemove', handleMouseMove);
    carousel.addEventListener('mouseup', handleMouseUp);
    carousel.addEventListener('mouseleave', handleMouseUp);

    return () => {
      carousel.removeEventListener('mousedown', handleMouseDown);
      carousel.removeEventListener('mousemove', handleMouseMove);
      carousel.removeEventListener('mouseup', handleMouseUp);
      carousel.removeEventListener('mouseleave', handleMouseUp);
    };
  }, [isDragging, startX, currentX]);

  return (
    <section className="testimonial-section">
      <div className="testimonial-container">
        {/* Top Section - Client Success Stories */}
        <div className="testimonial-header">
          <h2 className="testimonial-title">Client Success Stories</h2>
          <p className="testimonial-subtitle">
            Hear from our satisfied customers about their experience working with CodeGenexis.
          </p>
        </div>

        {/* Bottom Section - Sticky Note Testimonials Carousel */}
        <div className="testimonials-carousel">
          <div className="carousel-container" ref={carouselRef}>
            <div className="testimonials-grid">
              {getCurrentTestimonials().map((testimonial) => (
                <div key={testimonial.id} className={`sticky-note ${testimonial.color}`}>
                  <div className="note-content">
                    <p className="testimonial-text">{testimonial.content}</p>
                    <div className="note-author">{testimonial.author}</div>
                    <div className="note-context">{testimonial.context}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Carousel Dots Only */}
          <div className="carousel-dots">
            {Array.from({ length: totalSlides }, (_, index) => (
              <button
                key={index}
                className={`dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection; 